import React from 'react';
import { getCurrentVersion } from "../../../utils/versionChecker";

const DashboardFooter = () => {
    return (
        <footer className="dashboard-footer">
            <div className="d-flex justify-content-center align-items-center gap-2">
                <span>© {new Date().getFullYear()} HSSE. Crafted by M-SPHERE</span>
                <span>|</span>
                <a href="mailto:hsse.support@meinhardtepcm.com" style={{ color: '#013e7d', textDecoration: 'underline' }}>
                    hsse.support@meinhardtepcm.com
                </a>
                <span>|</span>
                <span style={{ color: '#6c757d', fontSize: '0.9rem' }}>v{getCurrentVersion()}</span>
            </div>
        </footer>
    );
};

export default DashboardFooter; 